import { render, staticRenderFns } from "./commentstocompanies.vue?vue&type=template&id=16c7f960&lang=html&"
import script from "./commentstocompanies.vue?vue&type=script&lang=js&"
export * from "./commentstocompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports